module.exports = __webpack_public_path__ + "img/rainbow.ae5b364e.png";